import * as React from 'react';
import { UitkLink } from 'uitk-react-link';
import { FlightsToggle, TogglePhase } from 'types/shared';
import { ButtonTracked } from 'components/shared/tracked';

export interface ToggleLinkProps {
  flightsToggle: FlightsToggle;
  handleActionClick?: () => void;
  expandedLink?: boolean;
}

export const ToggleLink = ({ flightsToggle, handleActionClick, expandedLink }: ToggleLinkProps) => {
  const { expandActionable, collapseActionable } = flightsToggle;
  const togglePhase: TogglePhase = expandedLink ? collapseActionable : expandActionable;

  return (
    <UitkLink>
      <ButtonTracked
        onClick={handleActionClick}
        {...togglePhase.analytics}
        aria-label={togglePhase.accessibilityMessage}
      >
        {togglePhase.action}
      </ButtonTracked>
    </UitkLink>
  );
};
